module.exports = __webpack_public_path__ + "6ac3ed90028731a505d595122fcc202d.jpg";